<div class="page-name">
  <h3>{{ 'contact-us.page-name' | translate }}</h3>
</div>

<div class="profile-navigation">
  <div class="item" (click)="navigateAccount()">
    <p class="subtitle-14">{{ "account-navigation.account" |  translate }}</p>
  </div>

  <div class="item active">
    <p class="subtitle-14">{{ "account-navigation.contact-us" |  translate }}</p>
  </div>

  <div class="item" (click)="navigateVouchers()">
    <p class="subtitle-14">{{ "account-navigation.vouchers" |  translate }}</p>
  </div>
</div>

<div class="form">
  <div class="row">
    <div class="title">
      <p class="subtitle-14">{{ 'contact-us.reason-title' | translate }}</p>
    </div>

    <div class="inline-select">
      <mat-select class="input flex-1" [(ngModel)]="selectedReason"
        [placeholder]="'contact-us.reason-placeholder' | translate">
        @for (reason of reasonList; track reason) {
          <mat-option [value]="reason.value">{{ reason.label }}</mat-option>
        }
      </mat-select>
    </div>
  </div>

  <div class="row">
    <div class="title">
      <p class="subtitle-14">{{ 'contact-us.message-title' | translate }}</p>
    </div>

    <div class="input textarea">
      <textarea class="input" [(ngModel)]="message"
      [placeholder]="'contact-us.message-placeholder' | translate"></textarea>
    </div>
  </div>
</div>

<div class="actions">
  <button class="button primary" [disabled]="!selectedReason || !message" (click)="sendContactUs()">
    {{ 'contact-us.submit-button' | translate }}
  </button>
</div>
